const DashboardIndex = () => import('@/modules/dashboards/views/DashboardIndex')
const DashboardShow = () => import('@/modules/dashboards/views/DashboardShow')

export default [
  {
    path: '/dashboards',
    name: 'dashboards.index',
    component: DashboardIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/dashboards/:id',
    name: 'dashboards.show',
    component: DashboardShow,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/dashboards/advertisers/:id',
    name: 'dashboards.advertiser.show',
    component: DashboardShow,
    meta: { requiresAuthentication: true }
  }
]
